var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgBackupBlack = function SvgBackupBlack(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.2V7.34C4.705 6.97 4 6.485 4 6c0-1 3-2 8-2s8 1 8 2c0 .332-.33.663-.954.959A9.037 9.037 0 0 1 22 9.343V6c0-2.21-4.477-4-10-4S2 3.79 2 6v12c0 1.812 3.013 3.343 7.144 3.834a9.045 9.045 0 0 1-1.862-2.201C5.176 19.253 4 18.626 4 18v-1.6c.641.342 1.416.64 2.293.885a8.995 8.995 0 0 1-.287-1.943C4.706 14.97 4 14.485 4 14v-1.6c.569.303 1.243.573 2 .8v-1.86c-1.295-.37-2-.855-2-1.34V8.4a11.05 11.05 0 0 0 2 .8Z",
    fill: "#667695"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20a5 5 0 1 0-4-8l1.146 1.146a.5.5 0 0 1-.353.854H9a1 1 0 0 1-1-1v-2.793a.5.5 0 0 1 .854-.354l.721.722a7 7 0 1 1-.5 8.156l1.633-1.165A4.998 4.998 0 0 0 15 20Z",
    fill: "#667695"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11a1 1 0 0 1 1 1v2.759l1.504.877a1 1 0 1 1-1.008 1.728l-2-1.167a1 1 0 0 1-.496-.864V12a1 1 0 0 1 1-1Z",
    fill: "#667695"
  })));
};

export default SvgBackupBlack;